import type {
  DraftJob as HirerGraphDraftJob,
  DraftJobsQuery,
} from 'src/graphql/__generated__';
import type { DraftJob } from 'src/types';
import { mapNullOrEmptyToUndefined } from 'src/utils/mapNullOrEmptyToUndefined';

const mapTitle = (title: string | null): string | undefined =>
  title && title.trim().length > 0 ? title : undefined;

const mapGraphqlDraftJobToDraftJob = (
  draftJob: HirerGraphDraftJob,
): DraftJob => ({
  draftId: draftJob.id,
  createdBy: draftJob.owner?.fullName,
  createdDate: draftJob.createdDate,
  title: mapTitle(draftJob.titles?.[0]?.title ?? null),
  advertiserReference: mapNullOrEmptyToUndefined(
    draftJob.advertiserJobReference,
  ),
  status: draftJob.status,
  location: draftJob.locationsV2?.[0],
});

export const mapDraftJobs = (
  jobResponse?: DraftJobsQuery['draftJobs'] | null,
): DraftJob[] => {
  if (jobResponse?.__typename !== 'JobsResponseSuccess') {
    return [];
  }
  const draftJobs = jobResponse.result.edges
    .map((edge) => edge.node)
    .filter(
      (draftJob): draftJob is HirerGraphDraftJob =>
        draftJob.__typename === 'DraftJob',
    );

  return draftJobs?.map(mapGraphqlDraftJobToDraftJob);
};
